// COUNT MANUPLIATION OF ITEMS IN  MENU
export const increment = "increment";
export const decrement = "decrement";
export const resetTheCount = "resetTheCount";

export const LIST_ACTIVE_MENU_FETCH_START = "LIST_ACTIVE_MENU_FETCH_START";
export const LIST_ACTIVE_MENU_FETCH_SUCCESS = "LIST_ACTIVE_MENU_FETCH_SUCCESS";
export const LIST_ACTIVE_MENU_FETCH_FAILURE = "LIST_ACTIVE_MENU_FETCH_FAILURE";

export const LIST_MENU_FETCH_START = "LIST_MENU_FETCH_START";
export const LIST_MENU_FETCH_SUCCESS = "LIST_MENU_FETCH_SUCCESS";
export const LIST_MENU_FETCH_FAILURE = "LIST_MENU_FETCH_FAILURE";

export const POST_MENU_START = "POST_MENU_START";
export const POST_MENU_SUCESS = "POST_MENU_START";
export const POST_MENU_FAILURE = "POST_MENU_START";

export const ADD_ORDER = "ADD_ORDER";
export const REMOVE_ORDER = "REMOVE_ORDER";
export const RESET_ORDER = "RESET_ORDER";

export const GET_SINGLE_MENU_START = "GET_SINGLE_MENU_START";
export const GET_SINGLE_MENU_SUCCESS = "GET_SINGLE_MENU_SUCCESS";
export const GET_SINGLE_MENU_FAILURE = "GET_SINGLE_MENU_FAILURE";

export const PATCH_MENU_START = "PATCH_MENU_START";
export const PATCH_MENU_SUCCESS = "PATCH_MENU_SUCCESS";
export const PATCH_MENU_FAILURE = "PATCH_MENU_FAILURE";

export const RESET = "RESET";
